import { axios } from '@Root/API'

export const create = (id, payload) => {
	return axios.post(`engagement/${id}/student-registration`, payload)
}
